module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/common/entity-search-box/entity-search-box.component.scss
// module id = ./src/app/modules/common-module/common/entity-search-box/entity-search-box.component.scss
// module chunks = 9